module.exports = __webpack_public_path__ + "img/thumbnail_AfricanSpurredTortoise_m_normal.9e65d74f.png";